import type { MarketId } from '@morpho-org/blue-sdk'

/**
 * Markets automated by the Spark Liquidity Layer (VRM-5372). Hardcoded because
 * coverage has no API surface. VRM-5372 lists five further markets Spark has not
 * confirmed; they stay out, since the badge is a claim about how a market behaves.
 */
const SLL_MARKETS: ReadonlySet<string> = new Set([
  // Base
  '8453:0x9103c3b4e834476c9a62ea009ba2c884ee42e94e6e314a26f04d312434191836', // USDC/cbBTC 86%
  '8453:0x8793cf302b8ffd655ab97bd1c695dbd967807e8367a65cb2f4edaf1380ba1bda', // USDC/WETH 86%
  '8453:0x0ca10126f6c94cbd9cf0a48cc9516ae5e3dec5aa68303e6d988ee37c5149bf0d', // USDC/cbETH 77%
  '8453:0x1c21c59df9db44bf6f645d854ee710a8ca17b479451447e9f56758aee10a2fad', // USDC/cbETH 86%
  '8453:0x13c42741a359ac4a8aa8287d2be109dcf28344484f91185f9a79bd5a805a55ae', // USDC/wstETH 86%
  // Ethereum
  '1:0xb323495f7e4148be5643a4ea4a8221eef163e4bccfdedc2a6f4696baacbc86cc', // USDC/wstETH 86%
  '1:0x64d65c9a2d91c36d56fbc42d69e979335320169b3df63bf92789e2c8883fcc64' // USDC/cbBTC 86%
])

export const isSllMarket = (chainId: number, marketId: MarketId): boolean =>
  SLL_MARKETS.has(`${chainId}:${marketId.toLowerCase()}`)
